import Geometry from "@frog/source/utility/Geometry.js"
import Zone from "@frog/source/models/Zone.js"

export default class World {
    static getTerrain(world, position) {
        if(position == undefined) {
            return undefined
        }
        if(world.terrain[position.x + "x" + position.y] != undefined) {
            return world.terrain[position.x + "x" + position.y]
        }
        return undefined
    }
    static isOutOfBounds(world, position) {
        return position.x < 0
            || position.y < 0
            || position.z < 0
            || position.x >= world.width
            || position.y >= world.height
            // || position.z >= world.depth
    }
    static isEmptyPosition(world, position) {
        return world.terrain[position.x + "x" + position.y] == undefined
    }
    static hasCollision2({world, zone, position, previousPosition, nextPosition, options}) {
        return World.hasCollision(world, previousPosition || position, nextPosition || position, options, zone)
    }
    static hasCollision(world, previousPosition, nextPosition, options, zone) {
        options = options || {}
        options.isIgnoringLedges = options.isIgnoringLedges || false
        options.isIgnoringWallEdges = options.isIgnoringWallEdges || false
        options.isIgnoringCollision = options.isIgnoringCollision || false

        // TODO: DO YOU NEED TO ALSO PUT THIS COLLISION ELSEWHERE??
        if(options.isIgnoringLedges != true // TODO: Make a separate variable for this?
        && zone != undefined
        && Zone.isInBounds(zone, nextPosition) == false) {
            return true
        }

        if(options.isIgnoringLedges != true
        && World.isOutOfBounds(world, nextPosition) == true) {
            return true
        }
        if(options.isIgnoringWallEdges == false
        && previousPosition != undefined
        && world.edges != undefined) {
            const direction2 = Geometry.vector(previousPosition, nextPosition)
            const direction1 = Geometry.flip(direction2)
            const key1 = previousPosition.x + "x" + previousPosition.y + "x" + previousPosition.z + "/" + (direction1.x > 0 ? "+" : "") + direction1.x + "x" + (direction1.y > 0 ? "+" : "") + direction1.y
            const key2 = nextPosition.x + "x" + nextPosition.y + "x" + nextPosition.z + "/" + (direction2.x > 0 ? "+" : "") + direction2.x + "x" + (direction2.y > 0 ? "+" : "") + direction2.y
            let edge1 = world.edges[key1]
            let edge2 = world.edges[key2]
            if(edge1 != undefined
            || edge2 != undefined) {
                return true
            }
        }
        const terrain = world.terrain[nextPosition.x + "x" + nextPosition.y]
        if(options.isIgnoringLedges != true // TODO: Make a separate variable for this??
        && terrain == undefined) {
            return true
        }
        if(options.isIgnoringCollsion != true
        && terrain != undefined
        && terrain.hasCollision == true) {
            return true
        }
        if(options.isIgnoringTerrain != true
        && terrain != undefined
        && nextPosition.z != terrain.position.z + terrain.size.z) {
            return true
            // const MOVEMENT_SIZE = 1
            // if(Math.abs(nextPosition.z - (terrain.position.z + terrain.size.z)) > MOVEMENT_SIZE) {
            //     return true
            // }
        }
        // if(previousPosition != undefined
        // && terrain.shape == "ramp") {
        //     if((terrain.direction == "east" || terrain.direction == "west")
        //     && previousPosition.y != nextPosition.y) {
        //         return true
        //     }
        //     if((terrain.direction == "south" || terrain.direction == "north")
        //     && previousPosition.x != nextPosition.x) {
        //         return true
        //     }
        // }
        return false
    }
}
